import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const merchantStatusStyles = {
  title: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap-reverse;
    gap: ${theme.spacing(2, 2)};
    margin-bottom: ${theme.spacing(2)};
  `,
  accountInfoContainer: css`
    display: flex;
    flex-wrap: wrap;
    gap: ${theme.spacing(1, 5)};

    &:not(:last-of-type) {
      margin-bottom: ${theme.spacing(2)};
    }
  `,
  accountInfo: css`
    display: flex;
    flex-direction: column;
    margin: 0;
  `,
};

export const stripeCardStyles = {
  stripeLogo: css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(3)};
  `,
  dashboardLink: css`
    display: flex;
    flex-flow: row;
    align-items: center;
  `,
  dashboardLinkIcon: css`
    margin-left: ${theme.spacing(0.5)};
  `,
  heading: css`
    margin: ${theme.spacing(0, 0, 2)};
  `,
  payoutDescriptorContainer: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(1)};
  `,
  payoutDescriptorField: css`
    max-width: 350px;
  `,
  payoutDescriptorHelperText: css`
    margin-top: ${theme.spacing(1)};
  `,
  payoutDescriptorButton: css`
    align-self: end;
  `,
};
